/* tslint:disable */
/* eslint-disable */
/**
 * kms-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 * @enum {string}
 */
export var DerivationInfoCurveEnum;
(function (DerivationInfoCurveEnum) {
    DerivationInfoCurveEnum["ed25519"] = "Ed25519";
    DerivationInfoCurveEnum["secp256k1"] = "Secp256k1";
})(DerivationInfoCurveEnum || (DerivationInfoCurveEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var DerivationInfoAddressFormatEnum;
(function (DerivationInfoAddressFormatEnum) {
    DerivationInfoAddressFormatEnum["ethereum"] = "Ethereum";
    DerivationInfoAddressFormatEnum["solana"] = "Solana";
    DerivationInfoAddressFormatEnum["bitcoinSegwit"] = "BitcoinSegwit";
    DerivationInfoAddressFormatEnum["sui"] = "Sui";
})(DerivationInfoAddressFormatEnum || (DerivationInfoAddressFormatEnum = {}));
